import React from 'react';
import styles from './FeaturesSection.module.scss';
import FeatureVisual from './visuals/FeatureVisual';
import ChatbotVisual from './visuals/ChatbotVisual';
import ScoringAlgorithmVisual from './visuals/ScoringAlgorithmVisual';

const features = [
    {
        Visual: FeatureVisual,
        title: 'Everything You Need in One Place',
        subtitle: '1,200+ questions across all topics',
        description:
            'No more hunting across random websites or buying 5 different prep books. Just log in and start practicing.',
    },
    {
        Visual: ChatbotVisual,
        title: 'Never Feel Stupid for Asking Questions',
        subtitle: 'Stuck at midnight?',
        description:
            "Ask why choice B is wrong and get a patient, detailed breakdown in plain language. No judgment, no waiting. Ask follow-up questions. Ask to explain differently. As many times as you need, whenever you need!",
    },
    {
        Visual: ScoringAlgorithmVisual,
        title: 'Practice that Finds Your Gaps',
        subtitle: "Every question is chosen based on what you know and what you don't",
        description:
            "This system uses Item Response Theory to map your skills across all 8 SAT topics and targets the exact areas holding your score back.",
    },
];

const FeaturesSection = () => {
    return (
        <section className={styles.features} id="features" aria-label="Features">
            <div className={styles.header}>
                <p className={styles.eyebrow}>WHY PREPAL?</p>
                <h2 className={styles.heading}>Everything you need to crush the SAT</h2>
            </div>

            <div className={styles.grid}>
                {features.map((f, i) => (
                    <div className={styles.card} key={i}>
                        <div className={styles.cardVisualWrap}>
                            <f.Visual className={styles.cardVisual} />
                        </div>
                        <div className={styles.cardBody}>
                            <h3 className={styles.cardTitle}>{f.title}</h3>
                            <p className={styles.cardSubtitle}>{f.subtitle}</p>
                            <p className={styles.cardDesc}>{f.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default FeaturesSection;
